import { Component, AfterViewInit } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
    constructor() { }

    scrollToFormIfLinkIsTrue() {
        const link = window.location.href;
        const reqEx = /oferta/;
        // const testDrive = /jazda-probna/;
        // const newsletter = /newsletter/;

        if (reqEx.test(link)) {
          setTimeout(() => {
            const sectionForm = document.getElementById('sectionOfferForm');
            sectionForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 900);
        }
        // if (testDrive.test(link)) {
        //   setTimeout(() => {
        //     // const sectionForm = document.getElementById('sectionOfferForm');
        //     // sectionForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
        //     console.log('show test drive');
        //   }, 900);
        // }
        // if (newsletter.test(link)) {
        //   setTimeout(() => {
        //     // const sectionForm = document.getElementById('sectionOfferForm');
        //     // sectionForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
        //     console.log('show newsletter');
        //   }, 900);
        // }
      }

      scrollTo1stSection() {
        const link = window.location.href;
        const reqEx = /tradein/;
        const reqEx1 = /zlapokazje/;
        if (reqEx.test(link)) {
          setTimeout(() => {
            const sectionTradeIn = document.getElementById('sectionTradeIn');
            sectionTradeIn.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 900);
        }
        if (reqEx1.test(link)) {
          setTimeout(() => {
            const sectionTradeIn = document.getElementById('sectionTradeIn');
            sectionTradeIn.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 900);
        }
      }

      scrollToform() {
        // const input = document.getElementById('inputFormOffer');
        // input.scrollIntoView({ behavior: "smooth", block: "start" });
        const input = document.getElementById('sectionOfferForm');
        if (input !== null) {
            const offsetTopMargin = 70;
            window.scroll({
              top: input.offsetTop - offsetTopMargin,
              behavior: 'smooth',
          });
        }
    }

    ngAfterViewInit() {
        // this.scrollToFormIfLinkIsTrue();
        // this.scrollTo1stSection();
      }
}
